/**
 * API base URL — read once from `PUBLIC_API_URL` at build time.
 *
 * Not user-configurable: the deployment ships with the right host baked in.
 * The value comes from the repo-root `.env` (the single source of truth
 * shared with iOS — see `next.config.ts` and `scripts/ios-xcodegen.sh`).
 *
 * The OpenAPI paths already include the `/api` prefix (FastAPI mounts every
 * route under `/api`), so the value here is the host root — strip a trailing
 * `/` or `/api` so the env value is forgiving either way.
 */

function normalize(url: string): string {
  return url.trim().replace(/\/+$/, '').replace(/\/api$/, '');
}

const API_URL = normalize(
  process.env.PUBLIC_API_URL || 'http://127.0.0.1:8000',
);

export function getApiUrl(): string {
  return API_URL;
}
